import { ActionTypes } from '../actions';

const initialState = {
  all: [],
  current: {},
};

const PersonalNotesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_PERSONALNOTES:
      return { all: action.payload, current: state.current };
    case ActionTypes.FETCH_PERSONALNOTE:
      return { all: state.all, current: action.payload };
    case ActionTypes.UPDATE_PERSONALNOTE:
      return { all: state.all, current: action.payload };
    case ActionTypes.DELETE_PERSONALNOTE:
      return { all: action.payload, current: {} };
    case ActionTypes.CREATE_PERSONALNOTE:
      return { all: state.all, current: action.payload };
    default:
      return state;
  }
};

export default PersonalNotesReducer;
